import React from "react";
import DropDownOptions from "./druid/constants/dropDownOptions";
import { Dropdown, DropdownMenuItemType, IDropdownOption, IDropdownStyles } from 'office-ui-fabric-react/lib/Dropdown';

const dropdownStyles: Partial<IDropdownStyles> = { dropdown: { width: 300 } };

interface IOption {
    key: string,
    text: string,
    itemType?: DropdownMenuItemType,
}

const createDropDownOptions = (options: string[]): IOption[] => (
    options.map((option) => (
        {
            key: option,
            text: option,
        }
    ))
);

const retrieveOptionType = (id: string): string => {
    switch(id) {
        case 'bubbleBorderStyle':
        case 'bubbleFromUserBorderStyle':
        case 'suggestedActionBorderStyle':
        case 'suggestedActionDisabledBorderStyle':
        
            return 'borderStyles';
        
        case 'monospaceFont':
        case 'primaryFont':

            return 'fonts';
        
        case 'suggestedActionLayout':

            return 'suggestedActionLayout';
        
        case 'timestampFormat':

            return 'timestampFormat';
        
        case 'messageActivityWordBreak':

            return 'wordBreak';
        case 'position':
            return 'position';
        case 'scrollToEndButtonBehavior':
            return 'scrollToEndButtonBehavior';
        case 'bubbleNubOffset':
        case 'bubbleFromUserNubOffset':
            return 'bubbleNubOffset';
        case 'default':
        default:

            return 'default';
    }
}

interface DefaultSelectorProps {
    id: string;
    value: any;
    onChange: (styleElementName: string, value: any) => void;
}

export const DropDownSelector = (props: DefaultSelectorProps) => {
    const {id, value, onChange } = props;
    const [selectedItem, setSelectedItem] = React.useState<IDropdownOption>();
    
    const setValue = (
            event: React.FormEvent<HTMLDivElement>,
            option?: IDropdownOption | undefined,
            index?: number | undefined
        ): void => {
            let toSetValue: any = option?.text;
            if(toSetValue === "off") {
                toSetValue = false;
            }
            onChange(id, toSetValue);
            setSelectedItem(option);
    };

    const optionType: string = retrieveOptionType(id);
    // console.log(id);
    // console.log(optionType);
    // console.log(' ');
    
    const dropDownOptions: IOption[] = createDropDownOptions(DropDownOptions[optionType]);
    
    // (selectedItem.key as any === false ? "off": selectedItem.key)
    return (
       <Dropdown
            selectedKey={selectedItem ? (selectedItem.key as any === false ? "off": selectedItem.key) : undefined}
            onChange={setValue}
            // defaultValue={value === false ? "off": value}
            placeholder={value === false ? "off": value}
            options={dropDownOptions}
            styles={dropdownStyles}
        />
    );
};
